<template>
  <div class="mobile-margin">
    <div class="d-flex justify-content-between align-items-center flex-wrap">
      <p class="recommendHeading">Recommendations</p>
      <button class="r-btn" :style="{ background: recommended ? '#e2e8f0' : getPrimaryColor(), border: 'none !important', color: recommended ?  '#47556E' : 'white', 'pointer-events': recommended ? 'none': 'auto' }" @click="handleRecommend">
        <font-awesome-icon :icon="[`${recommended ? 'fas' : 'fal'}`, 'thumbs-up']" :style="{ 'background-color': recommended ? '#e2e8f0' : getPrimaryColor() }" class="mr-2" />
        {{ recommended ? "Recommended" : "Recommend" }}
      </button>
    </div>

    <div class="d-flex mt-4 recommendHeadingBox">
      <div class="d-flex align-items-center flex-grow-1 providersSection">
        <font-awesome-icon :icon="['fas', 'thumbs-up']" class="likebg hide-in-mobile" :style="{ 'background-color': getPrimaryColor() }" />
        <div class="m-3">
          <div class="mob-count">
            <font-awesome-icon :icon="['fas', 'thumbs-up']" class="likebg show-in-mobile mr-2" :style="{ 'background-color': getPrimaryColor() }" />
            <p class="fw700 mb-0 gray900 font20">
              {{ treatment.provider_reviewer_count || 0 }}
            </p>
          </div>
          <p class="font12 fw700 m-mt8 mb-0 gray400 text-center">
            {{ treatment.provider_reviewer_count > 1 ? "Providers" : "Provider" }}
            Recommend this {{ treatment.treatment_type ? treatment.treatment_type.toLowerCase() : "complimentary therapy" }}
          </p>
        </div>
      </div>
      <div class="separator"></div>
      <div class="d-flex align-items-center flex-grow-1 justify-content-end usersSection">
        <font-awesome-icon :icon="['fas', 'thumbs-up']" class="likebg hide-in-mobile" :style="{ 'background-color': getPrimaryColor() }" />
        <div class="m-3">
          <div class="mob-count">
            <font-awesome-icon :icon="['fas', 'thumbs-up']" class="likebg show-in-mobile mr-2" :style="{ 'background-color': getPrimaryColor() }" />
            <p class="fw700 mb-0 gray900 font20">
              {{ treatment.user_reviewer_count || 0 }}
            </p>
          </div>
          <p class="font12 fw700 m-mt8 mb-0 gray400 text-center">
            {{ treatment.user_reviewer_count > 1 ? "Users" : "User" }}
            Recommend this {{ treatment.treatment_type ? treatment.treatment_type.toLowerCase() : "complimentary therapy" }}
          </p>
        </div>
      </div>
    </div>

    <div v-if="loading" class="d-flex justify-content-center my-3">
      <div>
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">Loading...</div>
    </div>

    <template v-else>
      <div class="d-flex flex-column shadow-card mt-3" v-for="recommendation in recommendations" :key="recommendation.id">
        <div class="align-items-center d-flex" v-if="recommendation.reviewer">
          <img
            v-if="recommendation.reviewer[0].url"
            class="rounded-circle hw70 cp"
            :src="recommendation.reviewer[0].url"
            alt="recommendation profile photo"
            @click="viewProfile(recommendation.reviewer[0])"
          />
          <img
            v-else-if="recommendation.reviewer[0].image"
            class="rounded-circle cp hw70"
            :src="recommendation.reviewer[0].image"
            alt="recommendation profile photo"
            @click="viewProfile(recommendation.reviewer[0])"
          />
          <div
            v-else
            class="rounded-circle cp hw70 flex-center-center font27 font-white cp"
            :style="{ 'background-color': getAvatarColor(recommendation.reviewer[0].id) }"
            @click="viewProfile(recommendation.reviewer[0])"
          >
            {{ getInitials(recommendation.reviewer_role, recommendation.reviewer[0]) }}
          </div>
          <div class="d-flex flex-column align-items-start flex-grow-1 ml-3 cp" @click="viewProfile(recommendation.reviewer[0])">
            <p class="fw700 text-capitalize">
              {{ getDisplayName(recommendation.reviewer_role, recommendation.reviewer[0]) }}
            </p>
            <p
              v-if="['doctor', 'hospital_administrator', 'clinic_administrator', 'physician', 'ohcp', 'hcp', 'nfp_administrator', 'business_administrator'].includes(recommendation.reviewer_role)"
              class="font12 fw700 recRole flex-center-center text-capitalize"
            >
              <font-awesome-icon :icon="['fal', 'user-md']" v-if="recommendation.reviewer_role === 'doctor' || recommendation.reviewer_role === 'physician'" />
              <font-awesome-icon :icon="['fal', 'user-nurse']" v-if="recommendation.reviewer_role === 'ohcp' || recommendation.reviewer_role === 'hcp'" />
              <font-awesome-icon :icon="['fal', 'hospital-alt']" v-if="recommendation.reviewer_role === 'hospital_administrator'" />
              <font-awesome-icon :icon="['fal', 'hospital']" v-if="recommendation.reviewer_role === 'clinic_administrator'" />
              <font-awesome-icon :icon="['far', 'hand-holding-heart']" v-if="recommendation.reviewer_role === 'nfp_administrator'" />
              <font-awesome-icon :icon="['far', 'store']" v-if="recommendation.reviewer_role === 'business_administrator'" />
              {{ getDisplayRole(recommendation.reviewer_role) }}
            </p>
            <p
              class="font12 fw700 recRole flex-center-center text-capitalize"
              :style="{ color: getPrimaryColor(), background: getPrimary50Color() }"
              v-if="recommendation.reviewer_role === 'caregiver'"
            >
              <font-awesome-icon :icon="['far', 'hands-heart']" />
              Caregiver
            </p>
            <div class="d-flex gap8 advCont" v-if="recommendation.reviewer_role === 'advocate'">
              <p class="font12 fw700 recRole flex-center-center text-capitalize" :style="{ color: getPrimaryColor(), background: getPrimary50Color() }">
                <font-awesome-icon :icon="['fas', 'bullhorn']" class="mr-1" />
                Advocate
                <!-- for
                {{ currentCircle.condition_type.slice(0, 20) }}
                {{ currentCircle.condition_type.length > 20 ? "..." : "" }} -->
              </p>
              <p v-if="recommendation.reviewer[0].organization" class="font12 fw700 recRole flex-center-center text-capitalize bg-purple50 purple300 ml-2">
                Supporting {{ recommendation.reviewer[0].organization }}
              </p>
            </div>
            <p class="font12 gray400">
              {{ formatTime(recommendation.created_at) }}
            </p>
          </div>
          <font-awesome-icon :icon="['fas', 'thumbs-up']" class="likebg" :style="{ 'background-color': getPrimaryColor() }" />
        </div>
      </div>
    </template>

    <a-pagination
      v-if="recommendations.length && totalCount > 5"
      v-model="currentPage"
      show-less-items
      :pageSize="5"
      @change="handleChangePage"
      :total="totalCount"
      class="d-flex justify-content-center"
    />
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core"
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import { faBullhorn } from "@fortawesome/pro-solid-svg-icons"
import { faHandsHeart, faHandHoldingHeart } from "@fortawesome/pro-regular-svg-icons"

library.add(faBullhorn, faHandsHeart, faHandHoldingHeart)
const UserRepository = RepositoryFactory.get("user")

export default {
  data() {
    return {
      recommended: null,
      recommendations: [],
      currentPage: 1,
      totalCount: 0,
      loading: false,
    }
  },

  props: { treatment: Object },

  created() {
    this.recommended = this.treatment.user_recommend
    this.getMedRecommendations()
  },

  methods: {
    getDisplayRole(role) {
      switch (role.toLowerCase()) {
        case "hospital_administrator":
          return "Hospital"
        case "clinic_administrator":
          return "Clinic"
        case "nfp_administrator":
          return "Non For Profit"
        case "hcp":
        case "ohcp":
          return "Advanced Practice Provider"
        default:
          return role
      }
    },
    getMedRecommendations() {
      this.loading = true
      UserRepository.getTreatmentReviews(this.currentCircle.id, this.currentPage, 5, this.treatment.id, this.treatment.treatment_type)
        .then(res => {
          this.loading = false
          if (Array.isArray(res.data.data) && res.data.data.length === 0) {
            this.recommendations = []
          } else {
            this.recommendations = res.data.data.data.filter(rev => rev.reviewer)
            this.totalCount = res.data.data.paginator ? res.data.data.paginator.total_count : 0
          }
        })
        .catch(e => {
          this.loading = false
        })
    },
    handleChangePage(page) {
      this.currentPage = page
      this.getMedRecommendations()
    },
    getDisplayName(reviewerRole, reviewerDetails) {
      switch (reviewerRole) {
        case "hospital_administrator":
        case "hospital":
          return reviewerDetails.hospital_name
        case "clinic_administrator":
        case "clinic":
          return reviewerDetails.clinic_name
        case "nfp":
        case "nfp_administrator":
          return reviewerDetails.nfp_name
        case "doctor":
        case "physician":
        case "hcp":
        case "ohcp":
          return reviewerDetails.first_name + " " + reviewerDetails.last_name
        // case "advocate":
        //   return reviewerDetails.first_name + " " + reviewerDetails.last_name
        default:
          return reviewerDetails.display_name || "~No Name~"
      }
    },
    getInitials(reviewerRole, reviewerDetails) {
      let f = "",
        l = ""
      switch (reviewerRole) {
        case "hospital_administrator":
        case "hospital":
          f = reviewerDetails.hospital_name ? reviewerDetails.hospital_name[0] : "H"
          break
        case "clinic_administrator":
        case "clinic":
          f = reviewerDetails.clinic_name ? reviewerDetails.clinic_name[0] : "C"
          break
        case "nfp":
        case "nfp_administrator":
          f = reviewerDetails.nfp_name ? reviewerDetails.nfp_name[0] : "N"
          break
        case "advocate":
          f = reviewerDetails.display_name.split(" ")[0][0] || "A"
          l =
            reviewerDetails.display_name
              .split(" ")
              .slice(1)
              .join(" ")[0] || ""
          break
        case "doctor":
        case "physician":
        // case "advocate":
        case "hcp":
        case "ohcp":
          f = reviewerDetails.first_name ? reviewerDetails.first_name[0] : "Dr"
          l = reviewerDetails.last_name ? reviewerDetails.last_name[0] : ""
          break
        case "patient":
        case "caregiver":
          f = reviewerDetails.display_name ? reviewerDetails.display_name[0] : "D"
          break
      }
      return f.toUpperCase() + l.toUpperCase()
    },
    handleRecommend() {
      if (!this.recommended) {
        const payload = {}

        payload["medication_type"] = this.treatment.treatment_type ? (this.treatment.treatment_type === "others" ? "medication" : this.treatment.treatment_type) : "nonmedicaltreatments"
        payload["medication_id"] = this.treatment.id
        payload["medication_name"] = this.treatment.display_name
        payload["reviewer_id"] =
          this.authUser.user.role === "patient" || this.authUser.user.role === "advocate" || this.authUser.user.role === "caregiver" ? this.authUser.user.id : this.authUser.user.ext_ref_id
        // payload["reviewer_id"] = this.authUser.user.id
        payload["reviewer_role"] = this.authUser.user.role
        payload["circle_id"] = this.currentCircle.id
        payload["recommend"] = true

        UserRepository.reviewMedication(payload)
          .then(res => {
            switch (this.authUser.user.role) {
              case "patient":
              case "advocate":
              case "caregiver":
                this.treatment.user_reviewer_count += 1
                break
              default:
                this.treatment.provider_reviewer_count += 1
                break
            }
            this.recommended = true
            this.getMedRecommendations()
          })
          .catch(err => {
            this.$notification.error({ message: "Failed", description: "Recommendation Not Successful" })
          })
      } else {
        this.$notification.error({ message: "Already Recommended", description: "Cannot recommend again" })
      }
    },
    formatTime(value) {
      const d = new Date(value)
      const now = new Date()
      const seconds = Math.round(Math.abs((now.getTime() - d.getTime()) / 1000))
      const minutes = Math.round(Math.abs(seconds / 60))
      const hours = Math.round(Math.abs(minutes / 60))
      const days = Math.round(Math.abs(hours / 24))
      const months = Math.round(Math.abs(days / 30.416))
      const years = Math.round(Math.abs(days / 365))
      if (Number.isNaN(seconds)) {
        return ""
      } else if (seconds <= 45) {
        return "a few seconds ago"
      } else if (seconds <= 90) {
        return "a minute ago"
      } else if (minutes <= 45) {
        return minutes + " minutes ago"
      } else if (minutes <= 90) {
        return "an hour ago"
      } else if (hours <= 22) {
        return hours + " hours ago"
      } else if (hours <= 36) {
        return "a day ago"
      } else if (days <= 25) {
        return days + " days ago"
      } else if (days <= 45) {
        return "a month ago"
      } else if (days <= 345) {
        return months + " months ago"
      } else if (days <= 545) {
        return "a year ago"
      } else {
        return years + " years ago"
      }
    },
    viewProfile(user) {
      this.loading = true
      if (user.id === this.authUser.user.id && user.role === this.authUser.user.role) {
        this.routeToAuthProfile(this.authUser.user.role)
      } else {
        UserRepository.getOtherUserProfile(user, this.currentCircle.id)
          .then(res => {
            const data = {
              ...res.data.data.user_info,
              on_circle: res.data.data.on_circle,
              request_to_add: res.data.data.request_to_add,
              no_of_members: res.data.data.no_of_members,
              recommendations: res.data.data.no_of_recommendations,
              recommend: res.data.data.recommend,
              overall_rating: res.data.data.overall_rating ? res.data.data.overall_rating : res.data.data.rating,
              inPersonReview: res.data.data.in_person_visit,
              onlineReview: res.data.data.online_tele_medicine,
              myCirclesReview: res.data.data.my_circle,
            }
            this.$store.commit("User/setViewUser", { data })
            switch (user.role) {
              case "doctor":
              case "physician":
                this.$router.push({ name: "ViewDoctorUpdates", params: { id: user.id } })
                break
              case "clinic_administrator":
                this.$router.push({ name: "ViewClinicAbout", params: { id: user.id } })
                break
              case "hospital_administrator":
                this.$router.push({ name: "ViewHos_adminAbout", params: { id: user.id } })
                break
              case "nfp":
                this.$router.push({ name: "ViewNfpAbout", params: { id: user.id } })
                break
              case "patient":
                this.$router.push({ name: "ViewPatientUpdates", params: { id: user.id } })
                break
              case "caregiver":
                this.$router.push({ name: "ViewPatientUpdates", params: { id: user.id, role: 'caregiver' } })
                break
              case "advocate":
                this.$router.push({ name: "ViewAdvocateAbout", params: { id: user.id } })
                break
              case "hospital":
                this.$router.push({ name: "HospViewAbout", params: { id: user.id } })
                break
              case "clinic":
                this.$router.push({ name: "ClinicViewAbout", params: { id: user.id } })
                break
              case "nfp_administrator":
                this.$router.push({ name: "ViewNfpAdminAbout", params: { id: user.id } })
                break
              default:
                break
            }
          })
          .catch(err => {})
      }
    },
  },
}
</script>

<style lang="scss" scoped>
img {
  object-fit: cover;
}
.shadow-card {
  p.gray400 {
    color: #94a3b8 !important;
  }
  p.recRole {
    color: #f5a623 !important;
  }
  p.gray500 {
    color: #647490 !important;
  }
  span.gray900 {
    color: #0f1734 !important;
  }
}
.recommendHeading {
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 0;
  margin: auto 0;
  @media screen and (max-width: 900px) {
    margin-right: 24px;
    // overflow-wrap: anywhere;
  }
}
.r-btn {
  border-radius: 6px;
  padding: 12px 24px;
  font-weight: 700;
  font-size: 14px;
  color: #fff;
  min-width: 151px;
}
.separator {
  background: #cbd5e1;
  width: 1px;
  height: 80%;
  margin: auto 0;
}
.recommendHeadingBox {
  background: #f1f5f9;
  height: 92px;
}
.recRole {
  line-height: 14px;
  text-align: center;
  background: #fff0d6;
  border-radius: 4px;
  padding: 4px 8px;
  gap: 4px;
}
.likebg {
  border-radius: 2px;
  padding: 4px;
  color: #fff;
}
@media screen and (max-width: 600px) {
  .mobile-margin {
    margin: 0 16px;
  }
  .mob-count {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .m-3 {
    margin-left: 0 !important;
  }
  .advCont {
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
  }
}
.providersSection {
  margin-left: 48px;
  @media screen and (max-width: 600px) {
    margin-left: 0px;
  }
}
.usersSection {
  margin-right: 48px;
  @media screen and (max-width: 600px) {
    margin-right: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/treatments/Recommendations.vue